const en = {
    adminLogIn: {
        part1: 'Admin',
        part2: ' log in'
    },
    ok: 'Ok',
    email: 'E-mail',
    companyEmail: 'Company Email',
    subscriptionPlan: 'Subscription plan',
    password: 'Password',
    signIn: 'Sign in',
    footerText: '© Replyco, 2025',
    logout: 'Logout',
    deletePicture: 'Delete picture',
    continue: 'Continue',
    upload: 'Upload',
    download: 'Download',
    copyToClipboard: 'Copy to ClipBoard',
    export: 'Export',
    period: 'Period',
    region: 'Region',
    refresh: 'Refresh',
    remove: 'Remove',
    actions: 'Actions',
    regionTypes: {
        all: 'All Region',
        0: 'United Kingdom',
        1: 'Germany'
    },
    country: 'Country',
    toast: {
        error: {
            message: 'Error',
            description: 'Something went wrong...'
        },
        success: {
            message: 'Success'
        },
        serverUnavailable: {
            description: 'Server is unavailable'
        },
        cannotSendAnEmptyNotification: {
            message: 'Warning',
            description: 'You can not send an empty notification'
        }
    },
    screens: {
        companies: 'Companies',
        integrations: 'Integrations',
        users: 'Users',
        feedback: 'NPS',
        dashboard: 'Dashboard',
        usageReport: 'Usage Report',
        cancellations: 'Cancellations',
        sync: 'Sync Jobs',
        auditTrail: 'Audit Trail'
    },
    auditTrail: {
        date: 'Date',
        admin: 'Admin',
        action: 'Action',
        target: 'Target',
        changes: 'Changes',
        ip: 'IP',
        filterAction: 'Filter by action',
        filterAdmin: 'Filter by admin',
        changesCount: '{{count}} field changed',
        changesCount_plural: '{{count}} fields changed'
    },
    companies: {
        stripeSubscriptionDetails: 'Stripe Subscription Details',
        shopifyBillingInfoCollapse: 'Shopify Billing Info',
        stripeSubscriptionId: 'Stripe subscription id',
        companyName: 'Company name',
        workPhone: 'Phone',
        email: 'Email',
        appLanguage: 'Application Language',
        registrationDate: 'Registration Date',
        trialExpire: 'Trial expire',
        selectedCompany: 'Selected company',
        actions: 'Actions',
        showDetails: 'Show details',
        hideDetails: 'Hide details',
        companyDetails: 'Company details',
        details: {
            companyId: 'Company ID',
            copy: 'Copy',
            copied: 'Copied',
            saveChanges: 'Save changes',
            manageManualSubscription: 'Manage manual subscription',
            revokeSubscription: 'Revoke subscription',
            tabs: {
                general: 'General',
                subscription: 'Subscription',
                features: 'Features',
                administration: 'Administration'
            },
            sections: {
                companyInformation: 'Company information',
                subscriptionDetails: 'Subscription details',
                datesAndLimits: 'Dates & limits',
                billingConfiguration: 'Billing configuration',
                companyFeatures: 'Company features'
            },
            summary: {
                typeProvider: 'Subscription type / provider',
                currentStatus: 'Current status',
                trialExpiration: 'Trial expiration date',
                trial: 'Trial',
                noPlan: 'No plan'
            },
            providers: {
                shopify: 'Shopify',
                manual: 'Manual',
                stripe: 'Stripe',
                none: 'None'
            },
            status: {
                active: 'Active',
                failed: 'Failed',
                expired: 'Expired',
                trial: 'Trial',
                none: 'No subscription'
            },
            dangerZone: {
                title: 'Danger zone'
            }
        },
        accountSetup: 'Account Setup',
        locationDetails: 'Locations Details',
        country: 'Country',
        state: 'State',
        city: 'City',
        address1: 'Address line 1',
        address2: 'Address line 2',
        zipCode: 'Zip Code',
        billingCountry: 'Billing country',
        billingState: 'Billing state',
        billingCity: 'Billing city',
        billingAddress1: 'Billing address 1',
        billingAddress2: 'Billing address 2',
        billingZipeCode: 'Billing Zipe Code',
        dataRemoveCollapse: 'Remove Data Details',
        dataLifetime: 'Tickets Data Lifetime (month)',
        ordersDataLifetime: 'Orders Data Lifetime (month)',
        feedbacksDataLifetime: 'Feedbacks Data Lifetime (month)',
        archiveThreadsLifetime: 'Archive tickets Lifetime (days)',
        deletedDataLifetime: 'Deleted Data Lifetime (days)',
        updateTrialExpire: 'Update trial expire date',
        notifiedAboutCompanyRemovingDate: 'Notified About Company Removing Date',
        deleteCompany: 'Delete company',
        search: 'Search',
        deleteCompanyConfirm:
            "Deleting company will automatically delete all its data, users. You won't be able to revert these changes.",
        manualSubscription: 'Manual subscription',
        manualSubscriptionExpire: 'Subscription expire',
        subscriptionDate: 'Subscription Date',
        paymentCustomerId: 'Payment Customer Id',
        isManualSubscribed: 'Manual Subscribed',
        subscription: 'Subscription',
        accountFilter: 'Filter by Integration details:',
        isCasesModuleActivated: 'Cases Module Activated',
        autoDraftEnabled: 'AI Auto Draft Enabled',
        subscriptionPlanEnum: {
            solo: 'Standard',
            team: 'Pro',
            advanced: 'Advanced',
            enterprise: 'Enterprise (new)',
            soloAnnual: 'Standard Annual',
            teamAnnual: 'Pro Annual',
            advancedAnnual: 'Advanced Annual',
            enterpriseAnnual: 'Enterprise Annual (new)',
            growth: 'Growth (new)',
            growthAnnual: 'Growth Annual (new)',
            business: 'Business (new)',
            businessAnnual: 'Business Annual (new)'
        },
        subscriptionPlanSelectPlaceholder: 'Please select a plan',
        updateManualSubscription: 'Update manual subscription',
        lastMonthTicketsCount: 'Tickets count',
        unlimited: 'Unlimited',
        billingUsage: 'Billing Usage',
        isOldSubscription: 'Old Pricing',
        failedSubscription: 'Failed subscription',
        subscriptionExpiredDate: 'Subscription failed / expired date',
        showUsedTicketsCount: 'Show used tickets count',
        integrationsCount: 'Integrations Count',
        endlessIntegrations: 'Endless Integrations',
        updateCompany: 'Update Company',
        customers: 'Customers',
        leads: 'Leads',
        all: 'All customers',
        sentMessagesIn24h: 'Sent in 24h',
        totalTicketsCount: 'Total tickets count',
        totalTicketsWithResponsesCount: 'Total tickets count with response',
        ticketsLimit: 'Tickets limit',
        ticketListReport: 'Ticket List Report',
        ticketsDuringTrialPeriod: 'Tickets during Trial period',
        enterpriseSubscription: 'Manual Subscription',
        removeSubscription: 'Revove Subscription',
        enterpriseFields: {
            numberOfTickets: 'Number of tickets',
            subscriptionExpire: 'Subscription expire',
            apply: 'Apply'
        },
        verified: 'Email verified',
        isManuallyVerified: 'Manually verified',
        shopifyBillingStatus: 'Shopify Billing Status',
        showPopupNotifications: 'Show popup notifications',
        manual: 'Manual',
        subscriptionFilter: {
            all: 'All subscriptions',
            stripe: 'Stripe',
            manual: 'Manual',
            shopify: 'Shopify'
        },
        features: {
            features: 'Features',
            chat: 'Chat',
            channelSpecificSignatures: 'Channel-specific signatures',
            whatsApp: 'Whats App',
            customFields: 'Custom fields',
            twoFactorAuthentication: 'Two Factor Authentication',
            dedicatedAccountManager: 'Dedicated account manager',
            agentCollisionsDetection: 'User collision detection',
            lifetimeHistoricalData: 'Lifetime historical data',
            channelSpecificTemplates: 'Channel-specific templates',
            autoresponses: 'Autoresponses',
            textSnippets: 'Text Snippets',
            translations: 'Translations',
            apiAccess: 'API Access (optional)',
            advancedReporting: 'Advanced reporting',
            smartFilters: 'Smart filters',
            userPermissions: 'User permissions',
            betaFeatures: 'Beta features',
            cases: 'Cases',
            feedbacks: 'Feedbacks',
            orderSync: 'Sync Orders',
            productSync: 'Sync Products',
            customerSync: 'Sync Customers',
            feedbackRequests: 'Feedback Requests',
            draftSaving: 'Draft Message Saving',
            calls: 'Calls',
            userRoles: 'User Roles',
            ebayInTicketCancellationReturnsRefunds: 'Ebay In Ticket Cancellation/Returns/Refunds',
            customisedPrioritiesAndSLA: 'Customised Priorities And SLA',
            liveChats: 'Live Chats (Widget)',
            ai: 'AI',
            copilot: 'Copilot'
        },
        customizeUI: {
            customizeUI: 'Customize UI',
            caption: 'Company caption:',
            logoLight: 'Light Logo:',
            miniLogoLight: 'Mini light logo:',
            logoDark: 'Dark Logo:',
            miniLogoDark: 'Mini dark logo:',
            primary: 'Primary:',
            success: 'Success:',
            warning: 'Warning:',
            error: 'Error:'
        },
        hasAccountFilter: 'Integration details',
        importThread: 'Import Tickets',
        importFromJSON: 'Import Tickets from JSON',
        notImportedThread: 'Not Imported Tickets:',
        importedThreadCount: ' Imported Tickets Count: {{count}}',
        notImportedThreadCount: 'Not Imported Tickets Count: {{count}}',
        importErrorDetails: 'Import Error Details:',
        shopifyBillingInfo: {
            shopUrl: 'Shop Url',
            status: 'Status',
            activationDate: 'Activation Date',
            createdDate: 'Created Date',
            subscriptionId: 'Subscription Id',
            tempReplycoSubscriptionId: 'Temp Replyco Subscription Id'
        },
        authOnboardingLogs: {
            title: 'Auth Onboarding Logs',
            steps: {
                start: 'Start',
                generalAccounts: 'Select General Accounts',
                mailAccounts: 'Select Mail Accounts',
                addAccount: 'Add Account'
            },
            step: 'Step',
            action: 'Action',
            data: 'Data',
            date: 'Date',
            isAuto: 'Redirect'
        }
    },
    users: {
        fullName: 'Full name',
        email: 'Email',
        lastLogin: 'Last login',
        lastUserAction: 'Last User Action',
        nextReviewDate: 'Next Review Date',
        userDetails: 'User details',
        phone: 'Phone',
        preferedLanguageCode: 'Preferred language',
        loginAsUser: 'Log in as user',
        unblockUser: 'Unblock user',
        revokeAllAuthorizations: 'Revoke All Authorizations',
        disableTwoFA: 'Disable 2FA',
        userActivities: 'User activities',
        admin: 'Admin',
        activities: {
            date: 'Date',
            action: 'Action',
            ip: 'IP'
        },
        notifications: {
            creationDate: 'Creation date',
            text: 'Text',
            read: 'Read',
            unRead: 'Unread',
            expiryDate: 'Expiry Date:',
            notRequired: '* Not required'
        },
        userNotifications: 'User notifications',
        newNotification: 'New notification',
        notificationForAllUsers: 'Notification for all users',
        sendNps: 'Send NPS',
        regionFilterActivatedWarning:
            'Region Filter is Activated. You will notify only {{region}} users'
    },
    integrations: {
        allIntegrations: 'All integrations',
        marketplace: 'Marketplace',
        name: 'Name',
        login: 'Login',
        shopCountry: 'Shop Country',
        shopCountrySelectPlaceholder: 'Please select Shop Country',
        shopRegion: 'Shop Region',
        shopRegionSelectPlaceholder: 'Please select Shop Region',
        shopBaseApiUrl: 'Shop URL',
        marketplaceLastSync: 'Last sync',
        marketplaceMessagesLastSync: 'Last Messages sync',
        marketplaceOrdersLastSync: 'Last Orders sync',
        marketplaceReturnsLastSync: 'Last Returns sync',
        restrictBlock: 'Restrict Block',
        receiveBlockNotification: 'Receive Notifications about Blocking',
        generalSettings: 'General settings',
        synchronization: 'Synchronization',
        blockingSettings: 'Blocking settings',
        administration: 'Administration',
        administrationSections: {
            accountAccess: 'Integration block',
            authentication: 'Reauthentication requirement',
            limits: 'Subscription-limit block',
            migrations: 'Integration type migrations'
        },
        administrationDescriptions: {
            accountAccess:
                'A full block stops all activity for this integration. A reason can be recorded and the customer can be notified; unblocking also clears sync, failure, and relogin flags.',
            marketplaceSync:
                'Stops only marketplace data synchronization without applying a full integration block. The customer can be notified when the block is applied.',
            authentication:
                'Marks the integration as requiring the customer to reconnect it before normal processing can continue.',
            limits:
                'Overrides the subscription block used when the company has more integrations than its plan allows. Customers cannot remove this block themselves.',
            migrateAmazonSp:
                'Converts a legacy Amazon integration to Amazon SP. The integration is blocked and requires the customer to reconnect it afterward.',
            migrateNativeOutlook:
                'Converts an email integration using outlook.office365.com to native Outlook authentication. The integration is blocked and requires the customer to reconnect it afterward.'
        },
        administrationMigrationTitles: {
            amazonToAmazonSp: 'Amazon to Amazon SP',
            smtpToOutlook: 'SMTP Outlook to native Outlook',
            ebayToRestApi: 'eBay to Rest API eBay',
            restApiToEbay: 'Rest API eBay to eBay'
        },
        smtpSettings: 'SMTP Settings',
        smtp: {
            password: 'Password',
            smtpServer: 'SMTP Server',
            smtpPort: 'SMTP Port',
            smtpUseSsl: 'SMTP Use SSL',
            protocolType: 'Protocol Type',
            protocolAddress: 'Protocol Address',
            protocolPort: 'Protocol Port',
            protocolUseSsl: 'Protocol Use SSL'
        },
        status: 'Status',
        needRelogin: 'Need Relogin?',
        isLockedTooltip: 'Integration is temporary blocked.',
        isMarketLockedTooltip: 'Marketplace data sync is temporary blocked.',
        needReloginTooltip: 'Need Relogin!',
        isUnlockedTooltip: 'Integration operating without any problems.',
        integrationDetails: 'Integration details',
        integrationId: 'Integration ID:',
        copy: 'Copy',
        copied: 'Copied',
        tabs: {
            general: 'General',
            smtp: 'SMTP',
            administration: 'Administration',
            logs: 'Logs'
        },
        integrationFindDetails:
            'You can find details about current integrations and change some of them.',
        syncIsInProgress: 'Account Sync is in progress now.',
        syncIsQueued: 'Account sync is queued.',
        blockingReason: 'Blocking reason:',
        syncIsQueuedNow: 'Sync is queued now.',
        unblock: 'Unblock',
        block: 'Block',
        fullIntegrationBlock: 'Full block',
        exceededLimitBlock: 'Exceeded Limit Block',
        exceededLimitUnblock: 'Exceeded Limit Unblock',
        exceededLimitBlockToolTip: "Users won't be able to unblock this integration by themself",
        unblockMarketSync: 'Unblock Market Sync',
        blockMarketSync: 'Block Market Sync',
        blockReason: 'Block reason',
        notifyAboutBlocking: 'Notify Customer',
        skipNotifyAboutBlocking: 'Skip Notification',
        prioritySync: 'Priority sync',
        syncTime: 'Sync time',
        min: 'min',
        sentMessages: 'Sent messages',
        setNeedRelogin: 'Set Need relogin',
        setRelogin: 'Set relogin',
        types: {
            marketplace: 'Marketplace',
            instantMessages: 'Instant messages',
            all: 'All'
        },
        statuses: {
            blocked: 'Blocked',
            notBlocked: 'Not Blocked',
            all: 'All Statuses'
        },
        logs: {
            logs: 'Logs',
            date: 'Date',
            action: 'Action',
            message: 'Message',
            actions: {
                1: 'Block',
                2: 'Unblock',
                3: 'Need Relogin',
                4: 'Relogin',
                5: 'Block Market Sync',
                6: 'Unblock Market Sync',
                7: 'Exceeded Limit Block',
                8: 'Exceeded Limit Unblock'
            }
        },
        migrateToAmazonSP: 'Migrate to Amazon SP',
        migrateToNativeOutlook: 'Migrate to Native Outlook',
        migrateToRestApiEbay: 'Migrate to Rest API eBay',
        migrateToRestApiEbayTitle: 'Migrate eBay to Rest API eBay?',
        migrateToRestApiEbayDescription:
            'Changes the marketplace type from eBay to Rest API eBay. The integration is blocked and requires the customer to reconnect it afterward.',
        migrateToRestApiEbaySuccessMessage: 'Migrated to Rest API eBay',
        migrateToRestApiEbaySuccessDescription:
            'Migration completed. The account now requires relogin through the existing eBay v2 / Rest API eBay auth flow.',
        migrateToEbay: 'Migrate to eBay',
        migrateToEbayTitle: 'Migrate Rest API eBay to eBay?',
        migrateToEbayDescription:
            'Changes the marketplace type from Rest API eBay to eBay. The integration is blocked and requires the customer to reconnect it afterward.',
        migrateToEbaySuccessMessage: 'Migrated to eBay',
        migrateToEbaySuccessDescription:
            'Migration completed. The account now requires relogin through the eBay auth flow.',
        removedThreads: 'Removed threads',
        filterByIntegrations: 'Filter by Integrations'
    },
    delete: {
        title: 'Are you sure?',
        yes: 'Yes',
        no: 'No'
    },
    cancel: 'Cancel',
    writeYourMessage: 'Write your message...',
    showPreview: 'Show preview',
    closePreview: 'Close preview',
    send: 'Send',
    downloadTickets: 'Download tickets',
    setupSettings: {
        labels: 'Labels',
        rules: 'Rules',
        templates: 'Templates',
        autoResponses: 'Auto-responses',
        customFields: 'Custom Fields',
        save: 'Save changes',
        cancel: 'Cancel',
        selectAll: 'Select All'
    },
    feedback: {
        noData: 'No message',
        message: 'Message',
        latestReview: 'Latest Review',
        skippedViews: 'Skipped views',
        filled: 'Reviews',
        promoters: 'Promoters',
        passives: 'Passives',
        detractors: 'Detractors',
        nps: 'NPS',
        repeatSurvey: 'Repeat survey',
        days: 'days',
        filterByRating: 'Filter by rating',
        timeComparison: 'Time Comparison',
        table: {
            companyName: 'Company Name',
            email: 'User Email',
            date: 'Date',
            rating: 'Rating',
            comment: 'Comment'
        },
        rate: {
            promoter: 'Promoter',
            detractor: 'Detractor',
            passive: 'Passive'
        },
        countTooltip: 'Count: {{count}}',
        chart: {
            promoters: 'Promoters',
            detractors: 'Detractors',
            passives: 'Passives'
        }
    },
    day: 'day',
    days: 'days',
    month: 'month',
    months: 'months',
    year: 'year',
    years: 'years',
    noData: 'No data',
    reviewDate: 'Review Date - ',
    comment: 'Comment: ',
    yes: 'Yes',
    no: 'No',
    save: 'Save',
    toggleModes: {
        on: 'On',
        off: 'Off'
    },
    today: 'Today',
    yesterday: 'Yesterday',
    last7Days: 'Last 7 days',
    last30Days: 'Last 30 days',
    last90Days: 'Last 90 days',
    selectPeriod: 'Select period',
    lastSync: 'Last Sync',
    orSelectCustomDates: 'Or select custom dates',
    allTime: 'All time',
    registrations: 'Registrations',
    subscriptionCancellations: 'Cancellations',
    threads: {
        numberId: 'Ticket ID',
        marketplace: 'Marketplace',
        accountName: 'Account Name',
        customerEmail: 'Customer Email',
        customerName: 'Customer Name',
        subject: 'Subject',
        createdDate: 'Created Date',
        marketOrderId: 'Market Order Id',
        trackingNumber: 'Tracking Number',
        searchBy:
            '*Search by Ticket ID, Subject, Customer Name&Email, Market customer Id, Market order Id, Tracking Number',
        threadDetails: 'Thread details',
        restore: 'Restore',
        removedAutomatically: 'Removed automatically',
        removedByUser: 'Remove by {{user}} (ID - {{id}})'
    },
    encrypt: {
        encrypt: 'Customer data',
        encryptedCustomersCount: 'Deleted customers',
        encryptedOrderCount: 'Deleted orders',
        enterCustomerData: 'Customer to delete'
    },
    createNewEmail: {
        email: 'Email',
        password: 'Password',
        createEmail: 'Replyco Email Account',
        protocolAddress: 'Protocol Address',
        protocolPort: 'Protocol Port',
        protocolType: 'Protocol Type',
        protocolUseSSL: 'Protocol Use SSL',
        smtpServer: 'SMTP Server',
        smtpPort: 'SMTP Port',
        smtpUseSSL: 'SMTP Use SSL'
    },
    incidentBar: {
        title: 'Incident Bar',
        activeLabel: 'Is Incident Active',
        save: 'Save'
    },
    dashboard: {
        overview: {
            registrationsUK: 'Registrations UK',
            registrationsDE: 'Registrations DE',
            conversions: 'Conversions',
            churnedUsers: 'Churned Users',
            payingUsers: 'Paying Users',
            tooltips: {
                registrations:
                    'Amount of Registrations that registared during selected period and in selected region',
                registrationsUK:
                    'Amount of Registrations from DE that registared during selected period',
                registrationsDE:
                    'Amount of Registrations from UK that registared during selected period',
                conversions:
                    'Number of companies registered within selected period who already bought subscription / all registered companies * 100%',
                churnedUsers:
                    'Number of companies registered within selected period who did not buy a subscription and their trial already expired / all registered companies',
                payingUsers: 'Companies who already have subscription'
            },
            removeRegistrationsConfirm:
                'Are you sure you want to remove selected registrations data?'
        },
        registrationsTable: {
            companyEmail: 'Company Email',
            registrationDate: 'Registration Date',
            trialExpire: 'Trial Expire',
            isRemoved: 'Removed',
            removedDate: 'Removed Date'
        },
        usageReport: {
            companyEmail: 'Company Email',
            lastSubPeriodStartDate: 'Last Sub Period Start Date',
            currentAndExpectedUsage: 'Current Usage / Expected Usage',
            ticketsLimit: 'Tickets Limit',
            overusage: 'Overusage',
            companySubscriptionPeriodTypes: {
                all: 'All',
                yearly: 'Yearly',
                monthly: 'Monthly'
            },
            subscriptonUsageTypes: {
                all: 'All',
                usageBased: 'Usage Based',
                unlimited: 'Unlimited (Old)'
            }
        },
        cancellations: {
            totalCost: 'Total Coast {{currency}}',
            cancellationsCount: 'Cancellations Count',
            cancellationDate: 'Cancellation Date',
            reason: 'Reason',
            comment: 'Comment',
            reasons: {
                0: 'Too Expensive',
                1: 'Missing Feature',
                2: 'Switching to Other Product',
                3: 'Techinical Issues',
                4: 'Other',
                5: 'Switching to Other Our Subscription'
            }
        },
        sync: {
            syncType: 'Sync Type',
            startJobTime: 'Start Job Time',
            companyId: 'Company Id',
            accountId: 'Account Id'
        }
    }
};

export default en;
